module.exports = __webpack_public_path__ + "static/media/3_Turn-Off-House-Power.470024e9.svg";